import {
  GET_COUPON_LIST,
  GET_COUPON_LIST_FAILURE,
  GET_COUPON_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getCouponListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUPON_LIST:
      return { ...state, loading: true };
    case GET_COUPON_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_COUPON_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getCouponListReducer;
